import { st, sym } from "rdflib";
import { vcard } from "../namespaces.js";
export function updateEmailAddress(emailAddressNode, newEmailAddress, store) {
    const oldValue = store.any(emailAddressNode, vcard("value"));
    const deletions = oldValue
        ? [st(emailAddressNode, vcard("value"), oldValue, emailAddressNode.doc())]
        : [];
    const insertions = [
        st(emailAddressNode, vcard("value"), sym("mailto:" + newEmailAddress), emailAddressNode.doc()),
    ];
    return {
        insertions,
        deletions,
        filesToCreate: [],
    };
}
//# sourceMappingURL=updateEmailAddress.js.map